import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoCashregItem} from "../cashreg-week/models/DtoCashregItem";
import {SharedService} from "../../shared/shared.service";

@Injectable()
export class CashregDayService {
    private apiUrl: string;

    constructor(private http: AzureApiService, private ss: SharedService) {
        this.apiUrl = 'administration'
    }

    public getCashregByDate = (checkDate: Date): Observable<DtoCashregItem[]> => {
        return this.http.get<DtoCashregItem[]>(`${this.apiUrl}/cashreg/day/${this.ss.formatDate(checkDate, 'yyyy-MM-dd')}`);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/administration/cashreg-day/cashreg-day.service.ts